import { create } from 'zustand';

interface CustomerStoryListingStore {
  search: string;
}

export const customerStoryFilterDefaultState = {
  search: '',
};

const useCustomerStoryListingStore = create<CustomerStoryListingStore>(() => customerStoryFilterDefaultState);

const updateSearch = (search: string) => ({ search });

export const setCustomerStorySearch = (search: string) =>
  useCustomerStoryListingStore.setState(() => updateSearch(search));

export const clearCustomerStoryFilters = () =>
  useCustomerStoryListingStore.setState(() => customerStoryFilterDefaultState);

export default useCustomerStoryListingStore;
